/*

👋 “Hey” from the Praxis team!

'apiConfig' is one pattern that can be used to set environment-based values at build time.
This happens by creating an environment variable REACT_APP_ENV, and then matching corresponding
keys to each environment in the 'envConfigs' object below. To learn more about how to set
REACT_APP_ENV, view the README generated with this app.


For an alternative pattern - using TAP configuration to set environment-based values at cluster initialization - see:
@praxis/component-runtime-env - https://praxis.prod.target.com/components/runtime-env

*/

import merge from 'lodash/merge';
import { config as analyticsConfig } from '@praxis/component-analytics';
//moved up to initialize before use
let hostname =
  typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : '';

// configurations shared between most or all environments can be stored in commonConfig
const commonConfig = {
  auth: {
    authorizationUrl:
      'https://oauth.iam.perf.target.com/auth/oauth/v2/authorize',
    logoutUrl:
      'https://logonservices.iam.perf.target.com/login/responses/logoff.html',
  },
  analytics: {
    appName: 'IoT Installer App',
  },
};

const envConfigs = {
  // dev is the default development environment set by .env.development and the default pipeline in .drone.yml
  dev: {
    apiKey: '55f755eaed8161eddf43a7a7e09b4553bd4b8e93',
    analyticsKey: '682b8244525747343fca4d1855c6f2361f45642e',
    analyticsUrl:
      hostname === 'iotinstall.perf.target.com' //if the host is external; then use the external analytics
        ? analyticsConfig.api.vNext.external.stage
        : analyticsConfig.api.vNext.internal.stage,
    otelKey: '23226a7d836568eb85b4155e9721c2621b1a2978',
    ADGroups: ['APP-OAuth2-IoT-Admin-stg', 'APP-IOT-RFID-Onboard'],
    auth: {
      // create a non-prod ID2.0 OAuth Client ID unique to your app needs at http://go/oauth
      // this clientID will not work in deployed environments
      clientId: 'polaris_rfid_ui_npe_im',
    },
    telemetryEnv: 'dev',
    ryderHost: 'https://iotinstall.perf.target.com',
    // ryderHost: 'https://ryder.dev.target.com',
    externalHost: 'https://iotinstall.perf.target.com',
    internalHost: 'https://iot-installer.dev.target.com',
    externalNeptuneHost: 'https://stage-api.target.com/store_maps/v1',
    retiredHost: 'polaris.dev.target.com',
  },
  /*
  // additional environments can be added:
  stg: {

  },
  */

  prod: {
    apiKey: '92badc893111db7119235712c087032b4864d582',
    analyticsKey: '5ecdc454bdbf60a2ebdd01fdead9ceeb62eb6da3',
    analyticsUrl:
      hostname === 'iotinstall.target.com'
        ? analyticsConfig.api.vNext.external.prod
        : analyticsConfig.api.vNext.internal.prod,
    otelKey: '23226a7d836568eb85b4155e9721c2621b1a2978',
    ADGroups: ['APP-OAuth2-IoT-Admin-Prod', 'APP-IOT-RFID-Onboard'],
    auth: {
      // keys in envConfigs will overwrite keys from commonConfig
      authorizationUrl: 'https://oauth.iam.target.com/auth/oauth/v2/authorize',
      logoutUrl:
        'https://logonservices.iam.target.com/login/responses/logoff.html',
      // clone your non-prod ID2.0 OAuth Client ID to a production Client ID at http://go/oauth',
      // this clientID will not work in deployed environments
      clientId: 'polaris_rfid_ui_prod_im',
    },
    telemetryEnv: 'prod',
    ryderHost: 'https://iotinstall.target.com',
    externalHost: 'https://iotinstall.target.com',
    internalHost: 'https://iot-installer.prod.target.com',
    externalNeptuneHost: 'https://api.target.com/store_maps/v1',
    retiredHost: 'polaris.prod.target.com',
  },
};

export const API_ROUTES = {
  generateTotp: '/rfid_device_onboard/v1/generate/totp',
  tokenValidation: '/rfid_device_onboard/v1/validate/totp',
  rfidOnboarding: '/rfid_device_onboard/v1/install/',
  rfidByLocation: '/rfid_device_onboard/v1/location_details/',
  lookupByLocation: '/rfid_device_onboard/v1/lookup/location_id/',
  lookupByDisplayName: '/rfid_device_onboard/v1/lookup/display_name/',
  lookupByMacAddress: '/rfid_device_onboard/v1/lookup/mac_address/',
  lookupByLogicalName: '/rfid_device_onboard/v1/lookup/logical_name/',
  mapByLocation: '/svg_images?location_id=',
  calibration: '/rfid_device_onboard/v1/calibrate/reader',
  orientationCalibration: '/rfid_device_onboard/v1/calibrate/orientation',
  locationCalibration: '/rfid_device_onboard/v1/calibrate/location',
  startCalibration: '/rfid_device_onboard/v1/calibrate/start',
  surveyLookupByLocation: '/pre_install_surveys/v1/submissions/',
  surveyResults: '/pre_install_surveys/v1/smartsheet/survey_results_status',
  lookupDevicesToCalibrate: '/rfid_device_onboard/v1/lookup/devices/',
  vestibuleLocation: '/pre_install_surveys/v1/vestibules/',
  vestibuleFormSubmit: '/pre_install_surveys/v1/vestibule',
};

export const DEVELOPMENT = 'dev';
export const PRODUCTION = 'prod';

export const ENV = {
  DEVELOPMENT,
  PRODUCTION,
};

export const appEnv =
  (hostname.endsWith('prod.target.com') &&
    !hostname.includes('shortstacksproxy')) ||
  hostname === 'iotinstall.target.com'
    ? ENV.PRODUCTION
    : ENV.DEVELOPMENT;
console.log({
  hostname,
  appEnv,
  config: envConfigs[appEnv],
  envConfigs,
});
const config = envConfigs[appEnv];

// commonConfig and the config for the matching REACT_APP_ENV are combined.
// Values in the environment-specific config will overwrite commonConfig keys
// if they share the same name.
const apiConfig = merge(commonConfig, config);

export default apiConfig;

// Uncomment for debugging
// if (process.env.NODE_ENV !== 'production') {
//   console.log(`${appEnv} ENV apiConfig:`, apiConfig);
// }
